
import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';

import { useNavigate, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { authKey, GET_SCHEDULE_APPROVAL_LIST, APPROVE_WEEKLY_SCHEDULE, DELETE_SCHEDULE } from '../../../common/URLs';
import jwt from 'jwt-decode';
import moment from 'moment';
import { Container, Grid, TextField, Button, Box, IconButton, Tooltip, Typography, Tab, Card } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PROD, PIT_ROLES } from "../../../common/constants";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import Badge from 'react-bootstrap/Badge';
import { Clear as CancelIcon, Done as ApproveIcon } from '@mui/icons-material';
import { VALIDATION, capitalizeFunction } from "../../../common/commonValidations";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import DeleteIcon from '@mui/icons-material/Delete';
import apiClient from "../../../axios";

function RBScheduleApproval() {

    const navigate = useNavigate();
    const role = localStorage.getItem('role');
    const isPlantOperator = [PIT_ROLES?.PlantSCMOperator, PIT_ROLES?.PitProcessingPlant].includes(role)
    const { state } = useLocation();
    const [errorMessage, setErrorMessage] = useState({
        noRecordError: '',
    });
    const decoded = jwt(getLocalStorageItem('id_token'));
    const [stakeholderDetails, setStakeholderDetails] = useState({});
    const [scheduleListData, setscheduleListData] = useState();
    const [bulkApprovePo, setbulkApprovePo] = useState();
    const [addComment, setAddComment] = useState('');
    const [isApiCalled, setIsApiCalled] = useState(false);

    const [scheduleToDelete, setScheduleToDelete] = useState();
    const [deletedSchedules, setDeletedSchedules] = useState();

    const [scheduleList, setscheduleList] = useState([]);
    const [tabValue, setTabValue] = useState(state?.tabVal ? state?.tabVal : "Pending");
    const [characterLimit] = useState(500);

    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);

    const [confirmOpen2, setConfirmOpen2] = useState(false);
    const handleConfirmOpen2 = () => setConfirmOpen2(true);
    const handleConfirmClose2 = () => setConfirmOpen2(false);

    const [confirmOpen3, setConfirmOpen3] = useState(false);
    const handleConfirmOpen3 = () => setConfirmOpen3(true);
    const handleConfirmClose3 = () => setConfirmOpen3(false);



    useEffect(() => {
        getScheduleList();
    }, [tabValue]);


    const getScheduleList = (e) => {
        loaderService.showLoader();
        apiClient
            .post(GET_SCHEDULE_APPROVAL_LIST,
                {
                    "type": tabValue,
                    "stakeholderUrn": "",
                    "materialType": "RB",
                    "destinationStakeHolderType": isPlantOperator ? "Plant" : getLocalStorageItem('role') === PIT_ROLES?.PitProcessingLLE ? "LLE" : "",
                    "destinationStakeHolderUrn": isPlantOperator ? "ABEPL" : ""
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setscheduleListData(response.data.weeklySchedulePlanDetailsList);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const columns = [
        { field: 'weeklyScheduleNumber', headerName: 'Schedule No', width: 250 },
        { field: 'scheduleLineNumber', headerName: 'Schedule Line No', width: 140 },
        {
            field: 'schedulePickupDate', headerName: 'Pick up Date', width: 130,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY")
        },
        { field: 'scheduleRbCbQuantity', headerName: 'Quantity', width: 100 },
        {
            field: 'stakeholderUrn', headerName: 'Source URN', width: 150
        },
        {
            field: 'stakeholderContactNo', headerName: 'Source Contact Details', width: 150
        },
        // {
        //     field: 'stakeholderLocationAddress', headerName: 'Source Location', width: 230
        // },
        {
            field: 'firstPartyName', headerName: 'Source Name', width: 230
        },
        {
            field: 'secondPartyUrn', headerName: 'Destination URN', width: 150,
        },
        {
            field: 'secondPartyContactNo', headerName: 'Destination Contact Details', width: 150,
        },
        // {
        //     field: 'secondPartyLocationAddress', headerName: 'Destination Location', width: 230,

        // },
        {
            field: 'secondPartyName', headerName: 'Destination Name', width: 230,

        },
        {
            field: 'scheduledDeliveryDate', headerName: 'Delivery Date', width: 130,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY")
        },
        { field: 'poStpoNumber', headerName: 'PO Number', width: 130 },
        { field: 'inventoryType', headerName: 'Type of Inventory', width: 130 },
        {
            field: 'Delete', width: 100,
            renderCell: (params) => {
                return (
                    <Tooltip title="Delete">
                        <IconButton size='small' color="error" aria-label="search"
                            onClick={() => onDeleteButtonClick(params.row)} disabled={params.row.isManuallyCreated !== true && (params.row.scheduleStakeholderType != "Grower" || params.row.scheduleStakeholderType != "HIT") || params.row.isConsignmentCreated === true}>
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                );
            }
        },

    ];

    const columns1 = [
        { field: 'weeklyScheduleNumber', headerName: 'Schedule No', width: 250 },
        { field: 'scheduleLineNumber', headerName: 'Schedule Line No', width: 130 },
        {
            field: 'schedulePickupDate', headerName: 'Pick up Date', width: 130,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        { field: 'scheduleRbCbQuantity', headerName: 'Quantity', width: 100 },
        {
            field: 'stakeholderUrn', headerName: 'Source URN', width: 150, hide: (tabValue === "Unloading" && stakeholderDetails?.category === "LLE"),
            renderCell: (cellValues) => {
                return (
                    tabValue === "Loading" ?
                        <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderUrn : cellValues?.row?.firstPartyUrn}</>
                        :
                        <> {cellValues?.row?.firstPartyUrn} </>
                );
            }
        },
        {
            field: 'stakeholderContactNo', headerName: 'Source Contact Details', width: 150, hide: (tabValue === "Unloading" && stakeholderDetails?.category === "LLE"),
            renderCell: (cellValues) => {
                return (
                    tabValue === "Loading" ?
                        <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderContactNo : cellValues?.row?.firstPartyContactNo}</>
                        :
                        <> {cellValues?.row?.firstPartyContactNo} </>
                );
            }
        },
        {
            field: 'firstPartyName', headerName: 'Source Name', width: 200
        },
        // {
        //     field: 'stakeholderLocationAddress', headerName: 'Source Location', width: 150, hide: (tabValue === "Unloading" && stakeholderDetails?.category === "LLE"), renderCell: (cellValues) => {
        //         return (
        //             tabValue === "Loading" ?
        //                 <>{cellValues?.row?.firstPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderLocationAddress : cellValues?.row?.firstPartyLocationAddress}</>
        //                 :
        //                 <> {cellValues?.row?.firstPartyLocationAddress} </>
        //         );
        //     }
        // },

        {
            field: 'secondPartyUrn', headerName: 'Destination URN', width: 150,
            renderCell: (cellValues) => {
                return (
                    tabValue === "Unloading" ?
                        <>{cellValues?.row?.secondPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderUrn : cellValues?.row?.secondPartyUrn}</>
                        :
                        <> {cellValues?.row?.secondPartyUrn} </>
                );
            }
        },
        {
            field: 'secondPartyContactNo', headerName: 'Destination Contact Details', width: 150,
            renderCell: (cellValues) => {
                return (
                    tabValue === "Unloading" ?
                        <>{cellValues?.row?.secondPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderContactNo : cellValues?.row?.secondPartyContactNo}</>
                        :
                        <> {cellValues?.row?.secondPartyContactNo} </>
                );
            }
        },
        {
            field: 'secondPartyName', headerName: 'Destination Name', width: 230,

        },
        // {
        //     field: 'secondPartyLocationAddress', headerName: 'Destination Location', width: 150,
        //     renderCell: (cellValues) => {
        //         return (
        //             tabValue === "Unloading" ?
        //                 <>{cellValues?.row?.secondPartyType === stakeholderDetails?.category ? cellValues?.row?.stakeholderLocationAddress : cellValues?.row?.secondPartyLocationAddress}</>
        //                 :
        //                 <> {cellValues?.row?.secondPartyLocationAddress} </>
        //         );
        //     }
        // },
        {
            field: 'scheduledDeliveryDate', headerName: 'Delivery Date', width: 130,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY")
        },
        { field: 'poStpoNumber', headerName: 'PO Number', width: 130 },
        { field: 'inventoryType', headerName: 'Type of Inventory', width: 150 },
        {
            field: 'isScheduledApproved', headerName: 'Approval Status', width: 150,
            valueFormatter: (params) => {
                if (params.value === true) {
                    return 'Approved';
                }
                else if (params.value === false) {
                    return 'Rejected';
                }
                else {
                    return '';
                }
            },
            // getCellValue: (params) => {
            //     if (params?.row?.scheduleStakeholderType === stakeholderDetails?.category) {
            //         return <>{params?.row?.isScheduledApproved}</>;
            //     } else if (params?.row?.firstPartyType === stakeholderDetails?.category) {
            //         return <>{params?.row?.isFirstPartyApproved}</>;
            //     } else {
            //         return <>{params?.row?.isSecondPartyApproved}</>;
            //     }
            // },
        },
        {
            field: 'Delete', width: 100,
            renderCell: (params) => {
                return (
                    <Tooltip title="Delete">
                        <IconButton size='small' color="error"
                            onClick={() => onDeleteButtonClick(params.row)} disabled={params.row.isManuallyCreated !== true && (params.row.scheduleStakeholderType != "Grower" || params.row.scheduleStakeholderType != "HIT") || params.row.isConsignmentCreated === true}>

                            <DeleteIcon />

                        </IconButton>
                    </Tooltip>
                );
            }
        },
    ];

    // const onConfirmApprove = (e) => {
    //     handleConfirmClose();
    //     onApprove(e);
    // }

    const onConfirmApprove = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await toApproveSchedule();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setConfirmOpen(false);
            setIsApiCalled(false);
        }
    };

    const onApproveButtonClick = (e) => {
        handleConfirmOpen();
    }

    // const onConfirmReject = (e) => {
    //     handleConfirmClose2();
    //     onReject(e);
    // }

    const onRejectButtonClick = (e) => {
        handleConfirmOpen2();
    }

    const onConfirmReject = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await toApproveSchedule();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setConfirmOpen2(false);
            setIsApiCalled(false);
        }
    };


    const onApprove = (e) => {
        var regex = /[-’/`~!#*$@_%+=^&(){}[\]|;:”<>?\\]/g;
        if (addComment == '' || addComment == null) {
            setErrorMessage({ ...errorMessage, noRecordError: "Please Enter Comment!" });
        }
        else if (regex.test(addComment)) {
            setErrorMessage({ ...errorMessage, noRecordError: "Please do not enter any special characters" });
        }

        else if (addComment.length > 500) {
            setErrorMessage({ ...errorMessage, noRecordError: "Please enter comments within 500 words" });
        }
        else {
            setErrorMessage({ ...errorMessage, noRecordError: "" });
            handleConfirmOpen();
        }
    }

    const onReject = (e) => {
        var regex = /[-’/`~!#*$@_%+=^&(){}[\]|;:”<>?\\]/g;
        if (addComment == '' || addComment == null) {
            setErrorMessage({ ...errorMessage, noRecordError: "Please Enter Comment!" });
        }
        else if (regex.test(addComment)) {
            setErrorMessage({ ...errorMessage, noRecordError: "Please do not enter any special characters" });
        }

        else if (addComment.length > 500) {
            setErrorMessage({ ...errorMessage, noRecordError: "Please enter comments within 500 words" });
        }
        else {
            setErrorMessage({ ...errorMessage, noRecordError: "" });
            handleConfirmOpen2();
        }
    }

    const toApproveSchedule = () => {
        loaderService.showLoader();
        apiClient
            .post(APPROVE_WEEKLY_SCHEDULE,
                {
                    "schedule_Id": scheduleList,
                    "scheduleApprovalComment": addComment,
                    //   "roleType": userLoggedIn 
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setbulkApprovePo(response.data);
                setAddComment('');
                getScheduleList();
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    useEffect(() => {
        if (bulkApprovePo) {
            if (bulkApprovePo.isSuccess === true) {
                toast.success(bulkApprovePo?.message)
            }
            else {
                toast.error(bulkApprovePo?.message ? bulkApprovePo?.message : "Error")
            }
        }
    }, [bulkApprovePo]);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    }
    const onTextValueChange = (e) => {
        e.preventDefault();
        setAddComment(VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 500)));
        setErrorMessage({ ...errorMessage, noRecordError: "" });
    }

    // const onConfirmDelete = () => {
    //     handleConfirmClose3();
    //     onDelete();
    // }

    const onDeleteButtonClick = (row) => {
        handleConfirmOpen3();
        setScheduleToDelete(row.id);
    }

    const onDelete = () => {
        onDeleteSchedule();
    }

    const onConfirmDelete = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await onDeleteSchedule();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setConfirmOpen3(false);
            setIsApiCalled(false);
        }
    };

    const onDeleteSchedule = () => {
        loaderService.showLoader();
        apiClient
            .post(
                DELETE_SCHEDULE,
                {
                    "scheduleId": scheduleToDelete,
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            )
            .then((response) => {
                setDeletedSchedules(response.data);
                getScheduleList();
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    useEffect(() => {
        if (deletedSchedules) {
            if (deletedSchedules.isSuccess === true) {
                toast.success(deletedSchedules?.message)
            } else {
                toast.error(deletedSchedules?.message ? deletedSchedules?.message : "Error")
            }
        }
    }, [deletedSchedules]);


    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT52</p>}
                <Typography variant="h4" gutterBottom>Weekly RB Schedules</Typography>
                <Card>
                    <TabContext value={tabValue} style={{ marginLeft: "1.5vh" }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'whitesmoke' }}>
                            <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                                <Tab label="Schedules" value="Pending" />
                                <Tab label="Approved Schedules" value="Approve" />
                            </TabList>
                        </Box>
                        <TabPanel value="Pending">
                            <Box style={{ height: 445, width: '100%' }}>
                                {
                                    scheduleListData &&
                                    <DataGrid rows={scheduleListData}
                                        columns={columns}
                                        pageSize={10}
                                        checkboxSelection
                                        getRowId={(row) => row.id}
                                        components={{ Toolbar: QuickSearchToolbar }}
                                        onSelectionModelChange={(newSelection) => {
                                            setscheduleList(newSelection.map(row => {
                                                let sNo = ""
                                                scheduleListData.forEach(so => {
                                                    if (row === so.id) {
                                                        sNo = so.id;
                                                    }
                                                })
                                                return sNo;
                                            }));
                                        }}
                                    />
                                }
                            </Box>
                            <Grid container mt={2}>
                                <Grid item xs={12} md={6}>
                                    <TextField fullWidth required
                                        error={errorMessage.noRecordError}
                                        helperText={errorMessage.noRecordError}
                                        autoComplete="off"
                                        id="outlined-multiline-static"
                                        label="Comments"
                                        multiline
                                        rows={4}
                                        onChange={(e) => onTextValueChange(e)}
                                        value={addComment}
                                        disabled={scheduleList.length < 1}
                                        sx={{ paddingRight: '15%' }}
                                    />
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '10%' }}>
                                        <Badge bg={`${addComment?.length > characterLimit ? 'danger' : 'primary'}`}>{addComment?.length}/{characterLimit}</Badge>
                                    </div>
                                </Grid>
                                <Grid item xs={12} lg={12}>
                                    <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                                        <Button sx={{ minWidth: 100 }} variant="contained" disabled={scheduleList?.length < 1} type="submit" onClick={(e) => onApprove(e)} startIcon={<ApproveIcon />}>Approve</Button>
                                        {/* <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" disabled={scheduleList?.length < 1} type="submit" onClick={(e) => onReject(e)} startIcon={<CancelIcon />}>Reject</Button> */}
                                    </Box>
                                </Grid>
                            </Grid>

                        </TabPanel>
                        <TabPanel value="Approve">
                            <Box style={{ height: 445, width: '100%' }}>
                                {
                                    scheduleListData &&
                                    <DataGrid rows={scheduleListData}
                                        columns={columns1}
                                        pageSize={10}
                                        components={{ Toolbar: QuickSearchToolbar }}
                                        getRowId={(row) => row.id}
                                    />
                                }
                            </Box>

                        </TabPanel>
                    </TabContext>
                </Card>

            </Container>
            <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmApprove} onClose={handleConfirmClose} action="Approve" />
            <ConfirmationPopover onOpen={confirmOpen2} onConfirm={onConfirmReject} onClose={handleConfirmClose2} action="Reject" />
            <ConfirmationPopover onOpen={confirmOpen3} onConfirm={onConfirmDelete} onClose={handleConfirmClose3} action="Delete Schedule" />

        </>
    );
}
export default RBScheduleApproval;

